import './index.erb';
import './index.rb';

class Header {
  constructor() {
    setTimeout(() => this.init(), 500);
  }

  init() {
    this.body = $('html, body');
    this.button = $('#vertical-notice-button');
    this.target = $('#vertical-notice');

    this.button.on('click', () => {
      this.goToVerticalNotice();
    });
  }

  goToVerticalNotice() {
    const scrollTop = this.target.offset().top;
    this.body.stop().delay(100).animate({ scrollTop }, 500, 'swing');
  }
}

(() => {
  new Header();
})();
